export default __webpack_public_path__ + "media/images/features/yado/kanki_ryoko-51fb8b9b0953a065e6be2be58c3cf62f.png";